import React from 'react';
import type { DialogCompositionProps, DialogContentProps } from '../dialog/Dialog';
import Dialog from '../dialog/Dialog';

export type ModalProps = Omit<DialogCompositionProps, 'trigger' | 'buttons'> & {
  variant?: Omit<DialogContentProps['variant'], 'dialog'>;
  /** If no trigger is supplied,  */
  trigger?: DialogCompositionProps['trigger'];
  closable?: DialogContentProps['closable'];
};

/**
 * Modal as thin wrapper around Dialog seems sufficient?
 */
export const Modal = ({ variant = 'modal', trigger, ...props }: ModalProps) => {
  return (
    <Dialog
      modal
      {...props}
      // We don't want non-triggered modal to leave an element/potential gap in the DOM
      trigger={trigger || <div style={{ display: 'none' }} />}
      variant={variant}
    />
  );
};
Modal.displayName = 'Modal';

export default Modal;
